// 业绩明细数据格式
const dataObj = {
  salesperson_name: '',
  total: {
    pay_fee: '',
    pay_num: '',
    user_num: '',
    order_num: ''
  },
  rebate_fee: {
    total: {
      confirm_rebate_fee: '',
      unconfirm_rebate_fee: ''
    },
    sales: {
      confirm_rebate_fee: '',
      unconfirm_rebate_fee: ''
    },
    store: {
      confirm_rebate_fee: '',
      unconfirm_rebate_fee: ''
    },
    binduser: {
      confirm_rebate_fee: '',
      unconfirm_rebate_fee: ''
    }
  },
  refund: {
    fee: '',
    num: ''
  },
  pay_fee: {
    online: {
      this_month: '',
      last_month: '',
      gap: 0
    },
    offline: {
      this_month: '',
      last_month: '',
      gap: 0
    }
  },
  pay_num: {
    online: {
      this_month: '',
      last_month: '',
      gap: 0
    },
    offline: {
      this_month: '',
      last_month: '',
      gap: 0
    }
  },
  user_num: {
    new: {
      this_month: '',
      last_month: '',
      gap: 0
    },
    bind: {
      this_month: '',
      last_month: '',
      gap: 0
    },
    pay: {
      this_month: '',
      last_month: '',
      gap: 0
    }
  }
}

export default dataObj
